import includes from 'lodash/includes';

import { 
  ZF_JSON_OBJECT_TYPE_PROPERTY, 
  ZF_JSON_OBJECT_VERSION_PROPERTY,
  ZF_JSON_IMAGE_TYPE
} from 'const_shared.js';


export const getDisplayNameForAssetType =(assetType)=> {
  return ({
    'video': 'Video',
    'photo': 'Photo',
    'youtube': 'YouTube',
    'pdf': 'PDF',
    'ppt': 'Presentation',
    'html_package': 'HTML Package',
    'other': 'File'
  })[assetType];
};

export const isAssetTypeCroppable = (assetType) => {
  // These asset types all have a custom thumbnail that should be croppable
  return includes(['photo', 'video'], assetType);
}

export const isAssetSrcSignable = (assetType) => {
  return includes(['photo'], assetType);
}

export const getZfImageForAsset = (asset) => {
  if(!asset){
    return null;
  }

  return {
    [ZF_JSON_OBJECT_TYPE_PROPERTY]: ZF_JSON_IMAGE_TYPE,
    [ZF_JSON_OBJECT_VERSION_PROPERTY]: 1,
    src: asset.displayImage,
    isUnsignable: !isAssetSrcSignable(asset.assetType),
    isUncroppable: !isAssetTypeCroppable(asset.assetType),
    isUncompressed: false,
    isUncompressable: !asset.isVector && !!asset.originalImage
  };
}

export const getZfImageForImageSrc = (imageSrc) => {
  return {
    [ZF_JSON_OBJECT_TYPE_PROPERTY]: ZF_JSON_IMAGE_TYPE,
    [ZF_JSON_OBJECT_VERSION_PROPERTY]: 1,
    src: imageSrc,
    isUncompressed: false, // We cannot really know without cropping the image or reading the asset
    isUncompressable: false // We cannot really know without cropping the image or reading the asset
  };
};

export const isVideoishAssetType = (assetType)=>
  (assetType === 'video' || assetType === 'youtube');